import { useMemo } from "react";
import { mapifyArray } from "../../utilities/mapifyArray";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

export default function ApplyChangesDialog({
    userData,
    pendingChanges,
    open,
    setOpen,
    onApply,
}) {
    const userDataMap = useMemo(() => mapifyArray(userData, "user_id"), [userData]);

    return (
        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogTitle>Apply changes?</DialogTitle>
            <DialogContent>
                {Object.entries(pendingChanges).map(([userId, changes]) => (
                    <Accordion key={userId}>
                        <AccordionSummary expandIcon={<ExpandMore />}>
                            <Typography>{userDataMap[userId].email}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {Object.entries(changes).map(([key, value]) => (
                                <Typography key={key}>
                                    {key}: {userDataMap[userId][key]} &#8594; {value}
                                </Typography>
                            ))}
                        </AccordionDetails>
                    </Accordion>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>Back</Button>
                <Button onClick={onApply}>Apply</Button>
            </DialogActions>
        </Dialog>
    );
}
